import type { ConditionStyleId, DynamicStyleId, StyleId } from '../types/Styles';
import { conditionsStyleIds } from './constants';

export const stackableOverlayIds = [
  'newHeatmap',
  'personalHeatmap',
  ...conditionsStyleIds,
  'publicLands',
  'privateLands',
  'fallFoliage',
  'wildfire',
  'slopeAngle',
  'highDefTerrain'
] as const satisfies readonly DynamicStyleId[];

export type StackableOverlayId = (typeof stackableOverlayIds)[number];

export const maxStackedOverlays = 3;

export const isStackableOverlay = (styleId: StyleId): styleId is StackableOverlayId => (stackableOverlayIds as readonly StyleId[]).includes(styleId);

const isConditionStyleId = (styleId: StyleId): styleId is ConditionStyleId => (conditionsStyleIds as StyleId[]).includes(styleId);

export const canAddStackedOverlay = (stackedOverlayIds: StackableOverlayId[], styleId: StackableOverlayId) =>
  stackedOverlayIds.length < maxStackedOverlays || (isConditionStyleId(styleId) && stackedOverlayIds.some(isConditionStyleId));

export const addStackedOverlay = <T extends DynamicStyleId>(dynamicStyleIds: T[], styleId: StackableOverlayId): (T | StackableOverlayId)[] => {
  const conditionIndex = isConditionStyleId(styleId) ? dynamicStyleIds.findIndex(isConditionStyleId) : -1;
  return conditionIndex === -1 ? [...dynamicStyleIds, styleId] : dynamicStyleIds.map((id, index) => (index === conditionIndex ? styleId : id));
};

export const toggleStackedOverlay = (stackedOverlayIds: StackableOverlayId[], styleId: StackableOverlayId) =>
  stackedOverlayIds.includes(styleId) ? stackedOverlayIds.filter(id => id !== styleId) : addStackedOverlay(stackedOverlayIds, styleId);

export const getOverlayCheckboxState = (stackedOverlayIds: StackableOverlayId[], styleId: StackableOverlayId) => {
  if (stackedOverlayIds.length === 0) {
    return undefined;
  }
  if (stackedOverlayIds.includes(styleId)) {
    return 'checked';
  }
  return canAddStackedOverlay(stackedOverlayIds, styleId) ? 'unchecked' : 'unavailable';
};
